import React, { useCallback } from 'react';
import classnames from 'classnames';
import { useUserID, Content } from '@yandex-lego/user';
import { useAuthManager } from '@funtech-int/yango-shared';

import { useLocale } from '@/shared/hooks/useLocale';
import { useClientSupport } from '@/shared/hooks/useClientSupport';
import { useLegal } from '@/app/hooks/useLegal';
import { useUserIdMenuQueryParams } from '@/app/hooks/useUserIdMenuQueryParams';
import { clientConfig } from '@/config/client';

import styles from './Profile.module.css';

interface UserIdMenuProps {
    dropDownMenuClassName: string;
    logoutLink: string;
    addMultiAccountLink?: string;
}

interface UserIdAccountChangePayload {
    uid: string;
    login: string;
    action: 'change' | 'auth';
}

const { userIdConfig, environment } = clientConfig;

export const UserIdMenu = (props: UserIdMenuProps) => {
    const { dropDownMenuClassName, logoutLink, addMultiAccountLink } = props;
    const locale = useLocale();
    const legalLink = useLegal();
    const { openClientSupport } = useClientSupport();
    const queryParams = useUserIdMenuQueryParams();
    const authManager = useAuthManager();

    const handleUserIdMenuClick = useCallback(
        (item: string, payload: unknown) => {
            switch (item) {
                case 'account-action':
                    // для чистоты слога нарушим рул, пейлоад используется только здесь
                    // eslint-disable-next-line no-case-declarations
                    const { uid, login, action } = payload as UserIdAccountChangePayload;

                    if (action === 'change') {
                        window.location.assign(
                            authManager.getChangeMultiAccountUrl(uid, new URL(window.location.href))
                        );
                    } else {
                        window.location.assign(
                            authManager.getAuthAccountUrl(login, new URL(window.location.href))
                        );
                    }
                    break;
                case 'add-account':
                    if (addMultiAccountLink) {
                        window.location.href = addMultiAccountLink;
                    }
                    break;
                case 'logout':
                    window.location.href = logoutLink;
                    break;
                case 'support-chat':
                    openClientSupport();
                    break;
                case 'legal':
                    window.location.href = legalLink;
                    break;
                default:
                    break;
            }
        },
        [addMultiAccountLink, logoutLink, openClientSupport, legalLink, authManager]
    );

    const { contentProps } = useUserID({
        project: userIdConfig.project,
        env:
            environment === 'production' || environment === 'prestable' || environment === 'stress'
                ? 'prod'
                : 'test',
        colorScheme: 'dark',
        host: userIdConfig.host,
        preload: true,
        onMenuItemClick: handleUserIdMenuClick,
        lang: locale.lang,
        dir: locale.dir,
        queryParams,
    });

    return (
        <div className={classnames(styles['dropdown-menu'], dropDownMenuClassName)}>
            <Content {...contentProps} width="100%" />
        </div>
    );
};
